import api from './api'

class AuthService {
    // 用户登录
    static async login(username, password) {
        // 使用API视图集中的login方法
        const response = await api.post('/userlog/login/', {
            username: username,
            password: password
        })
        return response.data
    }

    // 用户登出
    static async logout() {
        // 清除本地存储的用户信息
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        // 如果需要调用后端登出接口，可以在这里添加
        // const response = await api.post('/logout/')
        // return response.data
    }

    // 获取当前用户信息
    static getCurrentUser() {
        const user = localStorage.getItem('user')
        return user ? JSON.parse(user) : null
    }

    // 检查用户是否已登录
    static isLoggedIn() {
        return !!localStorage.getItem('user')
    }

    // 保存用户信息到本地存储
    static setUserInfo(user) {
        localStorage.setItem('user', JSON.stringify(user))
    }

    // 移除用户信息
    static removeUserInfo() {
        localStorage.removeItem('user')
    }
}

export default AuthService